import styled from 'styled-components';

const Paper = styled.div`
  min-width: 400px;
  min-height: 200px;
  background-color: #daf3a9;
  box-shadow: 10px 10px 25px -8px rgba(0, 0, 0, 0.5);
`;

export { Paper };


// WEBPACK FOOTER //
// ./src/components/UI/Paper.jsx